/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const MSA = lazyLoad(
  () => import('./index'),
  module => {
    return module.MSA;
  },
);
